import * as AxiosErrorProcessing from '@/services/api/AxiosErrorProcessing';
import Axios from 'axios';
import AppConfig from '@/configLoader';
import CookiesStorage from '../CookiesStorage';
import { logError } from '../logging/FaroLogger';
import { TelemetryErrorTypes } from '../logging/TelemetryEvents';
export default class AxiosService {
    static getDataFromServer(ajaxUrl, processError = true, abortSignal = null) {
        return this.getAxiosInstance()
            .get(ajaxUrl, abortSignal ? { signal: abortSignal } : {})
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return processError ? AxiosErrorProcessing.processError(error) : error.response;
        });
    }
    /**
     * Load data from 3rd party server (eg. Wordpress) without aouth and custom headers
     * @param ajaxUrl Remote URL
     * @returns
     */
    static getDataFrom3rdPartyServer(ajaxUrl) {
        return Axios.create()
            .get(ajaxUrl)
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return AxiosErrorProcessing.processError(error);
        });
    }
    static postDataToServer(ajaxUrl, data, processError = true) {
        return this.getAxiosInstance()
            .post(ajaxUrl, data)
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return processError ? AxiosErrorProcessing.processError(error) : error.response;
        });
    }
    static deleteDataFromServer(ajaxUrl, formData, processError = true) {
        return this.getAxiosInstance()
            .delete(ajaxUrl, { data: formData })
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return processError ? AxiosErrorProcessing.processError(error) : error.response;
        });
    }
    static downloadFile_POST(ajaxUrl, data, processError = true) {
        return this.getAxiosInstance(true)
            .post(ajaxUrl, data)
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return processError ? AxiosErrorProcessing.processError(error) : error.response;
        });
    }
    static downloadFile_GET(ajaxUrl, processError = true) {
        return this.getAxiosInstance(true)
            .get(ajaxUrl)
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return processError ? AxiosErrorProcessing.processError(error) : error.response;
        });
    }
    static putDataToServer(ajaxUrl, data, processError = true) {
        return this.getAxiosInstance()
            .put(ajaxUrl, data)
            .then((response) => response)
            .catch((error) => {
            logError(error, TelemetryErrorTypes.NETWORK, AxiosService.serializeError(error));
            return processError ? AxiosErrorProcessing.processError(error) : error.response;
        });
    }
    static getAxiosInstance(downloadingFile = false) {
        let options = {
            baseURL: AppConfig.getConfig()?.backend?.address,
            headers: this.createRequestHeader()
        };
        if (downloadingFile === true) {
            options.responseType = 'arraybuffer';
        }
        return Axios.create(options);
    }
    static GetWebSocketOptions() {
        const username = CookiesStorage.loadData(CookiesStorage.keys.USERNAME);
        const sessionPassword = CookiesStorage.loadData(CookiesStorage.keys.SESSION_PASSWORD);
        if (username == null && sessionPassword == null)
            return null;
        const credentials = `${username}:${sessionPassword}`;
        return btoa(credentials);
    }
    static getEncodedCredentials() {
        const username = CookiesStorage.loadData(CookiesStorage.keys.USERNAME);
        const sessionPassword = CookiesStorage.loadData(CookiesStorage.keys.SESSION_PASSWORD);
        if (username == null && sessionPassword == null)
            return false;
        const credentials = `${username}:${sessionPassword}`;
        return `Basic ${btoa(credentials)}`;
    }
    static createRequestHeader() {
        const encodedCredentials = this.getEncodedCredentials();
        return {
            'X-Authorization': encodedCredentials,
            'X-Application': AppConfig.getConfig()?.app.identifier
        };
    }
    static serializeError(error) {
        const serializedError = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            config: error.config,
            code: error.code,
            response: error.response
                ? {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    data: error.response.data,
                    headers: error.response.headers
                }
                : null
        };
        return JSON.stringify(serializedError);
    }
}
